module.exports = __webpack_public_path__ + "img/login-v2-dark.a9c67b9b.svg";